export type AgencyProviderPriceOverrideModel = {
  agency_id: number,
  cache_key: number,
  id: number,
  price_override: number,
  provider_id: number,
}

export type AgencyProviderPriceOverrideRequestOptions = {}

const state = {
  agency_id: null,
  id: null,
  price_override: null,
}

export const requiredFields = [
  { key: 'agency_id' },
]

export default state
